import { HttpMethod, httpClient } from './http-client';
import { PendingInteractionFormType } from '../@types/pendingInteraction.type';

export const getPendingInteractionsByServiceId = (serviceId: number): Promise<PendingInteractionFormType[]> => {
  return httpClient<PendingInteractionFormType[]>(`/pendingInteractions/${serviceId}`, HttpMethod.Get);
};
